// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"36ccded4","453":"77336051","732":"05d13cbd","977":"24fa1fa7"}[chunkId] + ".chunk.js";
};